import { IntlShape } from "react-intl";

export const getMainFilterOptions = (intl: IntlShape) => [
  { value: "name", label: intl.formatMessage({ id: "usAdmin.name" }) },
  {
    value: "contactName",
    label: intl.formatMessage({ id: "usAdmin.contactName" }),
  },
  { value: "address", label: intl.formatMessage({ id: "usAdmin.address" }) },
  { value: "city", label: intl.formatMessage({ id: "usAdmin.city" }) },
  { value: "state", label: intl.formatMessage({ id: "usAdmin.state" }) },
  { value: "country", label: intl.formatMessage({ id: "country" }) },
  { value: "zip", label: intl.formatMessage({ id: "usAdmin.zip" }) },
  { value: "phone", label: intl.formatMessage({ id: "usAdmin.phone" }) },
  { value: "email", label: intl.formatMessage({ id: "usAdmin.email" }) },
  {
    value: "industrySpecialist",
    label: intl.formatMessage({ id: "usAdmin.industrySpecialist" }),
  },
];

export const VENDORS_TABLE = {
  MOBILE_ROWS: 10,
  MOBILE_COLUMNS: 1,
  DESKTOP_ROWS: 10,
  DESKTOP_COLUMNS: 9,
};

export const VENDOR_SORT_KEYS = {
  NAME: "name",
  CONTACT_NAME: "contactName",
  ADDRESS: "address",
  CITY: "city",
  STATE: "state",
  ZIP: "zip",
  PHONE: "phone",
  EMAIL: "email",
  INDUSTRY_SPECIALIST: "industrySpecialist",
  COUNTRY: "country",
};
